module.exports = __webpack_public_path__ + "img/photo-01.7774ad9b.jpg";